<template>
    <div class="row">
        <!--List-->
        <div v-if="Object.keys(initial_briefings).length > 0" class="col-12">
            <list-of-operatives-signatures
                :data="initial_briefings"
                :show_url="show_url"
            ></list-of-operatives-signatures>
        </div>
        <div v-else class="col-12">
            <div class="flex-table text-center">
                <h5 class="m-4 mx-auto text-dark">No completed induction forms</h5>
            </div>
        </div>
    </div>
</template>

<script>
    import ListOfOperativesSignatures from "../forms/ListOfOperativesSignatures";
	export default {
		name: "InitialBriefingPage",
		components: {ListOfOperativesSignatures},
		props: [
        	'job',
            'initial_briefings',

            'can_crud_jobs',

            'show_url',
        ]
	}
</script>
